module.exports = __webpack_public_path__ + "static/media/barn.d8d1a3ee.png";